import styled from 'styled-components'
import { applyProps, PropTypesStyledHTML } from '../../../../utils/styled_helpers'

interface ImageProps extends PropTypesStyledHTML {
    full?: any,
    maxW?: any,
    maxH?: any,
    src?: any,
    alt?: any,
    h?: any,
}

export const Image = styled.img<ImageProps>`
    width: ${({ full }) => full ? '100%' : 'auto'};
    max-width: ${({ maxW }) => maxW || '100%'};
    max-height: ${({ maxH }) => maxH || '100%'};
    height: ${({ h }) => h || '100%'};
    ${(props) => applyProps(props)}
`
